import { html, type Html, Page, rune } from 'rune-ts';
import klass from './MembershipReceipt.module.scss';
import { PaymentReceiptWidget } from '@marpple/mco-membership-ui';
import { MembershipUtilS } from '../../../features/Membership/outbound/share';
import { MembershipErrorEnable } from '../../../features/Membership/error/error_enable';
import { MShopUtilF } from '../../../../../modules/MShop/Util/F/Function/module/MShopUtilF';
import { getActivatedSdkWithEvent } from '../../../features/Membership/util';
import { ConfigSentryF } from '../../../../../modules/Config/Sentry/F/Function/module/ConfigSentryF';

export type MembershipReceiptPageData = {
  membership_token?: string;
  payment_statement_id: string;
};

export class MembershipReceiptPage extends Page<MembershipReceiptPageData> {
  private _membershipErrorEnable = new MembershipErrorEnable(this);

  protected override template(): Html {
    return html` <div class="${klass.page}"></div> `;
  }

  protected override async onRender() {
    try {
      const client = await getActivatedSdkWithEvent(this.data.membership_token);

      const widget = new PaymentReceiptWidget({
        client,
        isMobile: this.isMobile,
        isApp: this.isApp,
        paymentStatementId: this.data.payment_statement_id,
        toggleSpinner: MembershipUtilS.toggleSpinner,
        onError: this._membershipErrorEnable.onError,
        onScrollLock: MShopUtilF.bodyFixed$,
      });

      widget.render(this.element());
    } catch (e) {
      ConfigSentryF.error(e);
      await this._membershipErrorEnable.openWidgetRenderErrorModal();
    }
  }

  get isMobile(): boolean {
    return !!rune.getSharedData(this)?.is_mobile;
  }

  get isApp(): boolean {
    return !!rune.getSharedData(this)?.webviewapp;
  }
}
